module.exports = __webpack_public_path__ + "media/src/assets/images/content/quiet-space-1f4bceba5b9ddd2e696c08cdf814b764.png";